import { c as _c } from "react/compiler-runtime";
import Layers from "@catchy/assets/svgs/layers.svg";
import IconButton from "./IconButton";

// One activation switches style. Keep this interaction shared across regions
// and main/trip maps; changing it requires an explicit product decision.
export default function MapStyleToggle(t0) {
  const $ = _c(8);
  const {
    preferSatellite,
    onChange
  } = t0;
  const t1 = preferSatellite ? "Show standard map" : "Show hybrid map";
  let t2;
  if ($[0] !== onChange || $[1] !== preferSatellite) {
    t2 = () => onChange(!preferSatellite);
    $[0] = onChange;
    $[1] = preferSatellite;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Layers aria-hidden="true" className="h-[1.25rem] w-[1.25rem]" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== preferSatellite || $[5] !== t1 || $[6] !== t2) {
    t4 = <IconButton label={t1} aria-pressed={preferSatellite} variant="map" onClick={t2}>{t3}</IconButton>;
    $[4] = preferSatellite;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}